var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"fixed"},[_c('div',{staticClass:"mask",on:{"click":function($event){$event.stopPropagation();return _vm.hide.apply(null, arguments)}}}),_c('div',{staticClass:"popup",style:({ '--bg': _vm.bgColor, '--maxW': _vm.maxW })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }